import { combineReducers } from 'redux';
import { actividadesAcademicasReducer } from '../modules/academico/actividades_academicas/ActividadesAcademicasReducer';
import { evaluacionesReducer } from '../modules/academico/evaluaciones/EvaluacionesReducer';
import { panelAcademicoReducer } from '../modules/academico/panel/PanelAcademicoReducer';
import { temasAcademicosReducer } from '../modules/academico/temas_academicos/TemasAcademicosReducer';
import { accesosReducer } from '../modules/accesos/AccesosReducer';
import { actividadesExtCurReducer } from '../modules/actividades_extcur/ActividadesExtcurReducer';
import { conceptosReducer } from '../modules/administracion/conceptos/ConceptosReducer';
import { recibosReducer } from '../modules/administracion/recibos/RecibosReducer';
import { archivosReducer } from '../modules/archivos/ArchivosReducer';
import { LoginReducer } from '../modules/auth/login/LoginReducer';
import { carnetReducer } from '../modules/carnet/CarnetReducer';
import { asistenciasReducer } from '../modules/control_estudios/asistencias/AsistenciasReducer';
import { aularioReducer } from '../modules/control_estudios/aulario/AularioReducer';
import { blopedFechasReducer } from '../modules/control_estudios/bloped_fechas/BlopedFechasReducer';
import { bloquesPedagogicosReducer } from '../modules/control_estudios/bloques_pedagogicos/BloquesPedagogicosReducer';
import { boletinesReducer } from '../modules/control_estudios/boletines/BoletinesReducer';
import { docentesReducer } from '../modules/control_estudios/docentes/DocentesReducer';
import { estudiantesReducer } from '../modules/control_estudios/estudiantes/EstudiantesReducer';
import { familiaresReducer } from '../modules/control_estudios/familiares/FamiliaresReducer';
import { horariosReducer } from '../modules/control_estudios/horarios/HorariosReducer';
import { materiasReducer } from '../modules/control_estudios/materias/MateriasReducer';
import { matriculasReducer } from '../modules/control_estudios/matriculas/MatriculasReducer';
import { matSeccionesReducer } from '../modules/control_estudios/matriculas/mat_secciones/MatSeccionesReducer';
import { notasEvaluativasReducer } from '../modules/control_estudios/notas/notas_evaluativas/NotasEvaluativasReducer';
import { periodosAcademicosReducer } from '../modules/control_estudios/periodos_academicos/PeriodosAcademicosReducer';
import { actExtraEstudiantesReducer } from '../modules/control_estudios/plan_evaluacion/actextra_estudiantes/ActExtraEstudiantesReducer';
import { actividadesExtrasReducer } from '../modules/control_estudios/plan_evaluacion/actividades_extras/ActividadesExtrasReducer';
import { pevaActividadesReducer } from '../modules/control_estudios/plan_evaluacion/peva_actividades/PevaActividadesReducer';
import { planEvaluacionReducer } from '../modules/control_estudios/plan_evaluacion/plan_evaluacion/PlanEvaluacionReducer';
import { planevaTemasReducer } from '../modules/control_estudios/plan_evaluacion/planeva_temas/PlanevaTemasReducer';
import { ptemEvaluacionesReducer } from '../modules/control_estudios/plan_evaluacion/ptem_evaluaciones/PtemEvaluacionesReducer';
import { seccionesReducer } from '../modules/control_estudios/secciones/SeccionesReducer';
import { dashboardReducer } from '../modules/dashboard/DashboardReducer';
import { direccionesReducer } from '../modules/direcciones/DireccionesReducer';
import { entAjustesReducer } from '../modules/entidad/ent_ajustes/EntAjustesReducer';
import { entCarrerasReducer } from '../modules/entidad/ent_carreras/EntCarrerasReducer';
import { entHorariosClasesReducer } from '../modules/entidad/ent_horario_clases/ent_horario_clases/EntHorarioClasesReducer';
import { entHorBloquesReducer } from '../modules/entidad/ent_horario_clases/enthor_bloques/EntHorBloquesReducer';
import { entHorDiasReducer } from '../modules/entidad/ent_horario_clases/enthor_dias/EntHorDiasReducer';
import { entMonedasReducer } from '../modules/entidad/ent_monedas/EntMonedasReducer';
import { entNivelesAcademicosReducer } from '../modules/entidad/ent_niveles_academicos/EntNivelesAcademicosReducer';
import { entVistasReducer } from '../modules/entidad/ent_vistas/EntVistasReducer';
import { entidadesReducer } from '../modules/entidad/entidades/EntidadesReducer';
import { eventosReducer } from '../modules/eventos/EventosReducer';
import { equiposReducer } from '../modules/juegos_deportivos/equipos/EquiposReducer';
import { equiposJuegosReducer } from '../modules/juegos_deportivos/equipos_juegos/EquiposJuegosReducer';
import { juegosReducer } from '../modules/juegos_deportivos/juegos/JuegosReducer';
import { jugadoresReducer } from '../modules/juegos_deportivos/jugadores/JugadoresReducer';
import { rondasReducer } from '../modules/juegos_deportivos/rondas/RondasReducer';
import { torneosReducer } from '../modules/juegos_deportivos/torneos/TorneosReducer';
import { notasBlopedReducer } from '../modules/notas/notas_bloped/NotasBlopedReducer';
import { permisosReducer } from '../modules/permisos/PermisosReducer';
import { reportesReducer } from '../modules/reportes/ReportesReducer';
import { carrerasReducer } from '../modules/sistema/carreras/CarrerasReducer';
import { deportesReducer } from '../modules/sistema/deportes/DeportesReducer';
import { estatusReducer } from '../modules/sistema/estatus/EstatusReducer';
import { modulosReducer } from '../modules/sistema/modulos/ModulosReducer';
import { monedasReducer } from '../modules/sistema/monedas/MonedasReducer';
import { nivelesAcademicosReducer } from '../modules/sistema/niveles_academicos/NivelesAcademicosReducer';
import { operadorasReducer } from '../modules/sistema/operadoras/OperadorasReducer';
import { perfilesReducer } from '../modules/sistema/perfiles/PerfilesReducer';
import { profesionesReducer } from '../modules/sistema/profesiones/ProfesionesReducer';
import { pagosSuscripcionReducer } from '../modules/sistema/suscripcion/pagos_suscripcion/PagosSuscripcionReducer';
import { suscripcionesReducer } from '../modules/sistema/suscripcion/suscripciones/SuscripcionesReducer';
import { systemReducer } from '../modules/sistema/system/SystemReducer';
import { tiposActividadesExtcurReducer } from '../modules/sistema/tipos_actividades_extcur/TiposActividadesExtcurReducer';
import { vistasReducer } from '../modules/sistema/vistas/VistasReducer';
import { tableroReducer } from '../modules/tableros/template/TableroReducer';
import { telefonosReducer } from '../modules/telefonos/TelefonosReducer';
import { ciudadesReducer } from '../modules/ubigeo/ciudades/CiudadesReducer';
import { estadosReducer } from '../modules/ubigeo/estados/EstadosReducer';
import { paisesReducer } from '../modules/ubigeo/paises/PaisesReducer';
import { usuEntPerfilesReducer } from '../modules/usuario/usu_ent_perfiles/UsuEntPerfilesReducer';
import { usuEntidadesReducer } from '../modules/usuario/usu_entidades/UsuEntidadesReducer';
import { usuProfesionesReducer } from '../modules/usuario/usu_profesiones/UsuProfesionesReducer';
import { usuVistasReducer } from '../modules/usuario/usu_vistas/UsuVistasReducer';
import { usuariosReducer } from '../modules/usuario/usuarios/UsuariosReducer';
import { templateReducer } from '../widgets/template/TemplateReducer';

const rootReducer = combineReducers({
  accesos: accesosReducer,
  actividadesAcademicas: actividadesAcademicasReducer,
  actividadesExtCur: actividadesExtCurReducer,
  actividadesExtras: actividadesExtrasReducer,
  actExtraEstudiantes: actExtraEstudiantesReducer,
  archivos: archivosReducer,
  asistencias: asistenciasReducer,
  aulario: aularioReducer,
  blopedFechas: blopedFechasReducer,
  bloquesPedagogicos: bloquesPedagogicosReducer,
  boletines: boletinesReducer,
  carnet: carnetReducer,
  carreras: carrerasReducer,
  ciudades: ciudadesReducer,
  conceptos: conceptosReducer,
  dashboard: dashboardReducer,
  deportes: deportesReducer,
  direcciones: direccionesReducer,
  docentes: docentesReducer,
  entAjustes: entAjustesReducer,
  entCarreras: entCarrerasReducer,
  entHorariosClases: entHorariosClasesReducer,
  entHorBloques: entHorBloquesReducer,
  entHorDias: entHorDiasReducer,
  entMonedas: entMonedasReducer,
  entNivelesAcademicos: entNivelesAcademicosReducer,
  entVistas: entVistasReducer,
  estatus: estatusReducer,
  entidades: entidadesReducer,
  estados: estadosReducer,
  estudiantes: estudiantesReducer,
  equipos: equiposReducer,
  equiposJuegos: equiposJuegosReducer,
  eventos: eventosReducer,
  familiares: familiaresReducer,
  evaluaciones: evaluacionesReducer,
  horarios: horariosReducer,
  juegos: juegosReducer,
  jugadores: jugadoresReducer,
  login: LoginReducer,
  modulos: modulosReducer,
  system: systemReducer,
  monedas: monedasReducer,
  materias: materiasReducer,
  matriculas: matriculasReducer,
  matSecciones: matSeccionesReducer,
  nivelesAcademicos: nivelesAcademicosReducer,
  notasEvaluativas: notasEvaluativasReducer,
  notasBloped: notasBlopedReducer,
  operadoras: operadorasReducer,
  pagosSuscripcion: pagosSuscripcionReducer,
  paises: paisesReducer,
  panelAcademico: panelAcademicoReducer,
  pevaActividades: pevaActividadesReducer,
  perfiles: perfilesReducer,
  permisos: permisosReducer,
  periodosAcademicos: periodosAcademicosReducer,
  planEvaluacion: planEvaluacionReducer,
  planevaTemas: planevaTemasReducer,
  profesiones: profesionesReducer,
  ptemEvaluaciones: ptemEvaluacionesReducer,
  recibos: recibosReducer,
  reportes: reportesReducer,
  rondas: rondasReducer,
  secciones: seccionesReducer,
  suscripciones: suscripcionesReducer,
  tablero: tableroReducer,
  telefonos: telefonosReducer,
  temasAcademicos: temasAcademicosReducer,
  template: templateReducer,
  tiposActividadesExtcur: tiposActividadesExtcurReducer,
  torneos: torneosReducer,
  usuarios: usuariosReducer,
  usuEntidades: usuEntidadesReducer,
  usuEntPerfiles: usuEntPerfilesReducer,
  usuProfesiones: usuProfesionesReducer,
  usuVistas: usuVistasReducer,
  vistas: vistasReducer,
});

export default rootReducer;
